$(document).ready(function() {
  const urlParams = new URLSearchParams(window.location.search);
  if (urlParams.get('contact_posted') === 'true') {
    window.location.href = 'https://malooracks.com/pages/thank-you';
  }
});
document.addEventListener("DOMContentLoaded", function () {

  const faqQuestions = document.querySelectorAll(".custom-faq .faq-question");

  faqQuestions.forEach(function (question) {

    question.addEventListener("click", function () {

      const answer = this.nextElementSibling;
      const icon = this.querySelector(".faq-icon");

      // Toggle active class
      this.parentElement.classList.toggle("active");

      // Toggle answer
      if (answer.style.display === "block") {
        answer.style.display = "none";
        icon.textContent = "+";
      } else {
        answer.style.display = "block";
        icon.textContent = "-";
      }

    });

  });

});
